import { type DriveOffData } from '@/types/Stack';
import { type DriveOff, columns } from './DriveOffsColumn';
import { DriveOffTableComponent } from '@/components/tables/DriveOffTableComponent';
import { useData } from '@/hooks/useData';



export default function DriveOffTable({
  driveOffsData,
}: {
  driveOffsData: DriveOffData[] | undefined;
}) {
  const { selectedLocation } = useData();
  function setData(driveOffsData: DriveOffData[]): DriveOff[] {
    if (!selectedLocation || selectedLocation.id === undefined) {
      return [];
    }
    const result = driveOffsData
      .filter(data => {
        const match = selectedLocation?.id === data.LocationID;
        return match;
      })
      .map(data => ({
        timeStamp: data.TimeStamp,
        location: selectedLocation,
        timeSpent: data.TimeSpent,
        modelId: data.ModelID.toString(), // Convert to string to match DriveOff interface
      })) as DriveOff[];
    return result as DriveOff[];
  }

  if (driveOffsData != null) {
    const data = setData(driveOffsData);

    return (
      <DriveOffTableComponent columns={columns} data={data} />
    );
  }
  return <></>;
}
